/**
 * @generated SignedSource<<afd9492db81ebe30cd426ba1d7d04c03>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FavoritesItemProvider_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useFavoritesItem_item">;
  readonly " $fragmentType": "FavoritesItemProvider_item";
};
export type FavoritesItemProvider_item$key = {
  readonly " $data"?: FavoritesItemProvider_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItemProvider_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesItemProvider_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "228bdc4d9cc77fc9976214f747a77cb0";

export default node;
